module.exports = __webpack_public_path__ + "img/pyszjrmfy.2bfb47ea.png";